__turbopack_context__.v({
  "banner": "PlasmicSecurityPracticesBanner-module__3i-tbG__banner",
  "clientCentricSecurityFeatures": "PlasmicSecurityPracticesBanner-module__3i-tbG__clientCentricSecurityFeatures",
  "commitmentToContinuousImprovement": "PlasmicSecurityPracticesBanner-module__3i-tbG__commitmentToContinuousImprovement",
  "comprehensiveDataProtection": "PlasmicSecurityPracticesBanner-module__3i-tbG__comprehensiveDataProtection",
  "container": "PlasmicSecurityPracticesBanner-module__3i-tbG__container",
  "contentColumn": "PlasmicSecurityPracticesBanner-module__3i-tbG__contentColumn",
  "contentRow": "PlasmicSecurityPracticesBanner-module__3i-tbG__contentRow",
  "exploreOurSecurityPractices": "PlasmicSecurityPracticesBanner-module__3i-tbG__exploreOurSecurityPractices",
  "h3": "PlasmicSecurityPracticesBanner-module__3i-tbG__h3",
  "heading": "PlasmicSecurityPracticesBanner-module__3i-tbG__heading",
  "line": "PlasmicSecurityPracticesBanner-module__3i-tbG__line",
  "p__bXqRl": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__bXqRl",
  "p__bf5L9": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__bf5L9",
  "p__csCwy": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__csCwy",
  "p__d64HE": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__d64HE",
  "p__dFjz8": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__dFjz8",
  "p__gVi2": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__gVi2",
  "p__gwY6G": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__gwY6G",
  "p__i2Evz": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__i2Evz",
  "p__j1Hf7": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__j1Hf7",
  "p__l3TcL": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__l3TcL",
  "p__lIi1U": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__lIi1U",
  "p__mfzMy": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__mfzMy",
  "p__ngqHp": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__ngqHp",
  "p__nhr3Y": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__nhr3Y",
  "p__qb6Bz": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__qb6Bz",
  "p__tz4BZ": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__tz4BZ",
  "p__ulLl3": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__ulLl3",
  "p__uuSZn": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__uuSZn",
  "p__xJnGj": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__xJnGj",
  "p__xv3X7": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__xv3X7",
  "p__ysH87": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__ysH87",
  "p__z9C9Z": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__z9C9Z",
  "p__znYdo": "PlasmicSecurityPracticesBanner-module__3i-tbG__p__znYdo",
  "proactiveRiskManagement": "PlasmicSecurityPracticesBanner-module__3i-tbG__proactiveRiskManagement",
  "questions": "PlasmicSecurityPracticesBanner-module__3i-tbG__questions",
  "rawLi___4NtPz": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi___4NtPz",
  "rawLi__eMg9M": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__eMg9M",
  "rawLi__eUtsq": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__eUtsq",
  "rawLi__gFnwO": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__gFnwO",
  "rawLi__j8Vlo": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__j8Vlo",
  "rawLi__kzby": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__kzby",
  "rawLi__lHHbQ": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__lHHbQ",
  "rawLi__nlqi2": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__nlqi2",
  "rawLi__og4Wi": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__og4Wi",
  "rawLi__ow6Gd": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__ow6Gd",
  "rawLi__penpq": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__penpq",
  "rawLi__sk78D": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__sk78D",
  "rawLi__vgqgC": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__vgqgC",
  "rawLi__yqRzX": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__yqRzX",
  "rawLi__zaeLo": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawLi__zaeLo",
  "rawUl___1WBeE": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawUl___1WBeE",
  "rawUl___40D6N": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawUl___40D6N",
  "rawUl__j19FH": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawUl__j19FH",
  "rawUl__lzEwi": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawUl__lzEwi",
  "rawUl__mqqw": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawUl__mqqw",
  "rawUl__qc28N": "PlasmicSecurityPracticesBanner-module__3i-tbG__rawUl__qc28N",
  "regulatoryCompliance": "PlasmicSecurityPracticesBanner-module__3i-tbG__regulatoryCompliance",
  "title": "PlasmicSecurityPracticesBanner-module__3i-tbG__title",
  "trainingAndAwareness": "PlasmicSecurityPracticesBanner-module__3i-tbG__trainingAndAwareness",
  "wrapper": "PlasmicSecurityPracticesBanner-module__3i-tbG__wrapper",
});
